<script lang="ts">
    import { slide } from "svelte/transition";

    export let open: boolean;
    export let onClose: () => void;
    export let addTransition: boolean = true;
    export let activator: HTMLElement = undefined;

    let containerElement: HTMLDivElement;

    function closeOnOutsideClick() {
        if (open && containerElement) {
            onClose();
        }
    }
    let topDelta = '';
    if (activator) {
        const box = activator.getBoundingClientRect();
        topDelta = `${box.height}px`;
    }
    const isRtl = document.documentElement.dir === "rtl";
</script>

<svelte:window on:click={closeOnOutsideClick} />
{#if open}
    <div class="z-10" bind:this={containerElement}>
        <div
            transition:slide={addTransition ? { duration: 300 } : undefined} style="top: {topDelta}"
            class="absolute max-h-screen bg-white shadow rounded border border-gray-300 menu text-gray-900
      text-sm py-2"
            class:menu__ltr={!isRtl}
            class:menu__rtl={isRtl}
            class:right-0={!isRtl}
            class:left-0={isRtl}
        >
            <ul class="whitespace-nowrap">
                <slot />
            </ul>
        </div>
    </div>
{/if}

<style>
    .menu {
        z-index: 1000;
    }

    .menu__ltr,
    .menu__ltr :global(button) {
        text-align: left !important;
    }

    .menu :global(a:hover) {
        color: unset;
    }

    .menu__rtl,
    .menu__rtl :global(button) {
        text-align: right !important;
    }
</style>
